<template>
    <div class="home">
        <!-- <button type="button" @click="comp.getVoices">ACTION</button> -->
    </div>
</template>

<script>
import { onMounted, reactive } from "vue";
// import { useRouter } from "vue-router";
import axios from "axios";

export default {
    
    setup() {
        // const router = useRouter();
        const comp = reactive({
            data: [],
            list: [],

            doSearch: () => {
                let params = { }
                axios
                    .get("/ai/sample_list", { params: params })
                    .then((res) => {
                        comp.data = res.data;
                    });
            },

            getVoices: () => {
                for(let i=0; i<comp.data.list.length; i++){
                    let irow = comp.data.list[i]

                    let params = { 
                        idx: irow.idx
                    }
                    axios.get("/ai/voice_list", { params: params }).then((res) => {
                        for(let j=0; j<res.data.list.length; j++){
                            let jrow = res.data.list[j]

                            axios.get("/ai/wav_test", { params: { idx:jrow.idx } })
                        }
                    });
                }
            }
        })

        onMounted(() => {
            // Mounted
            comp.doSearch();
        })

        return { comp };
    }
};
</script>
